module.exports = __webpack_public_path__ + "img/logo.344d0934.png";